import LeftSideLoginReg from "../elements/LeftSideLoginReg";
import ForgotPasswordForm from "../forms/ForgotPasswordForm";

const ForgotPassword: React.FC<{}> = () => {
  return (
    <div className="flex flex-row min-h-screen">
      <LeftSideLoginReg />
      <div className="w-[calc(100%*5/9)] flex flex-col justify-center">
        <div className="w-1/2 self-center">
          <h2 className="mb-4 text-4xl font-bold">Forgot password?</h2>
          <p className="mb-8 text-gray-500">
            No worries, we’ll send you reset instructions.
          </p>
          <ForgotPasswordForm />
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
